import { Create } from "@refinedev/mui";
import type { HttpError } from "@refinedev/core";
import { useForm } from "@refinedev/react-hook-form";
import { GemPackFields } from "./form";
import { editableOf, gemPackDefaults, type GemPackFormValues } from "./values";

export const CreditBundleCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading, onFinish },
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm<GemPackFormValues, HttpError, GemPackFormValues>({ defaultValues: gemPackDefaults });

  return (
    <Create
      isLoading={formLoading}
      title="Create Credits Pack"
      saveButtonProps={{
        ...saveButtonProps,
        onClick: handleSubmit((values) => onFinish({ key: values.key, ...editableOf(values) })),
      }}
    >
      <GemPackFields control={control} register={register} errors={errors} />
    </Create>
  );
};
